import Node from './node';

export default class ShowAllFilteredText extends Node {
  clone() {
    return new ShowAllFilteredText(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
